{	"main": {
		"title": "Pregled dnevnika",
		"nazaj": "Nazaj"
	},
	"navs": {
		"brisanje": "Brisanja",
		"urejanje": "Urejanja"
	},
	"table": {
		"titleJ": "JADRALNI LETI",
		"titleM": "MOTORNI LETI"
	},
	"modal": {
		"izbrisal": "Zapis izbrisal:",
		"reg": "registracija:",
		"vlecno": "vlečno letalo:",
		"pilot": "pilot:",
		"instruktor": "inštruktor:",
		"namen": "namen:",
		"naloga": "naloga:",
		"krajV": "kraj vzleta:",
		"krajP": "kraj pristanka:",
		"casV": "čas vzleta:",
		"casP": "čas pristanka",
		"casL": "čas letenja",
		"stPristankov": "št. pristankov:",
		"ifr": "ifr:",
		"nocno": "nocno:",
		"vizuelno": "vizuelno:",
		"opomba": "opomba:",
		"datumL": "datum letenja:",
		"datumV": "datum vnosa:",
		"datumB": "datum brisanja:",
		"regV": "reg. vleke:",
		"casO": "čas odklopa:",
		"casVL": "čas vleke:"
	}
}